/* eslint-disable */
import React from "react";
import * as MUI from "@material-ui/core";
import { createStyles } from "@material-ui/styles";
import { Theme, makeStyles } from "@material-ui/core";
import ArrowBackIcon from "@material-ui/icons/ArrowBack";
import cn from "classnames";

import { useReportId, IReportExportQuery } from "../../shared";
import BackButton from "../../../../components/BackButton";
import { ReportTitle } from "./ReportTitle";
import { ReportSubtitle } from "./ReportSubtitle";
import { Fullscreen } from "./Fullscreen";
import { Export } from "./Export";
import { Subscription } from "./Subscription";
import { Favourite } from "./Favourite";
import { Information } from "./Information";

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {
      height: theme.spacing(12),
      width: "100%",
      paddingLeft: theme.spacing(4),
      paddingRight: theme.spacing(4),
      paddingTop: theme.spacing(2.65),
      display: "flex",
      alignItems: "flex-start",
      flexShrink: 0,
      flex: "none",
      boxSizing: "border-box",
    },
    export: {
      background: "rgba(186, 218, 154, 1)",
      width: "100%",
      height: "auto",
      justifyContent: "flex-start",
      paddingLeft: theme.spacing(2),
      "&::before": {
        width: "160px",
        content: "url(/assets/images/chart.svg)",
        height: "160px",
        background: "rgba(100, 150, 50, 1)",
        marginTop: "-21px",
        paddingBottom: theme.spacing(2),
        marginRight: theme.spacing(3),
        marginLeft: theme.spacing(3),
        display: "flex",
        alignItems: "flex-end",
        justifyContent: "center",
      },
      "&::after": {
        position: "absolute",
        content: "'For Internal Use Only!'",
        color: "red",
        top: theme.spacing(-3),
        left: theme.spacing(5),
        fontWeight: "bold",
        fontStyle: "italic",
        textDecoration: "underline",
      },
      "& h1": {
        fontWeight: "bold",
        lineHeight: "40px",
        fontSize: "32px",
      },
      "& h2": {
        fontWeight: "bold",
        lineHeight: "32px",
        fontSize: "24px",
        opacity: 0.9,
      },
    },
    leftSide: {
      display: "flex",
      flexDirection: "column",
      alignItems: "flex-start",
    },
    rightSide: {
      display: "flex",
      alignItems: "flex-end",
      paddingRight: theme.spacing(4),
      color: theme.palette.text.secondary,
      marginLeft: "auto",
    },
  })
);

export type Props = {
  className?: string;
  title: string;
  subtitle?: string;
  description?: string[];
  loading?: string;
  exportMode?: boolean;
};

export function ReportHeader(props: Props) {
  const classes = useStyles(props);
  const { title, subtitle, description, exportMode } = props;

  return (
    <>
      <MUI.Toolbar className={cn(classes.root, { [classes.export]: exportMode })}>
        {exportMode ? null : <BackButton />}
        <div className={classes.leftSide}>
          <ReportTitle>{title}</ReportTitle>
          <ReportSubtitle>{subtitle}</ReportSubtitle>
        </div>
        {exportMode ? null : (
          <div className={classes.rightSide}>
            <Favourite />
            <Information description={description} />
            <Export />
            <Subscription />
            <Fullscreen />
          </div>
        )}
      </MUI.Toolbar>
      <MUI.Divider />
    </>
  );
}

export default ReportHeader;
